// const serveUrl = 'https://cdn.yndycx.net/homesite_forntend_v3'
const serveUrl = 'https://dytz-website.obs.cn-south-1.myhuaweicloud.com/homesite_forntend_v3'

export const ossImgUrl = (url) => `${serveUrl}/${url}.png`
